module.exports = "/_next/static/images/3fec5c898551fd55285ad37d72ab94e9-hero-xs.jpg.webp";